export default __webpack_public_path__ + "static/media/100.94086225.svg";